export const MODERN_SCREENSHOT_WORKER_URL = "/modern-screenshot-worker.js";
